export default __webpack_public_path__ + "static/media/nodelogo.ca6c7625.png";